/**
 * Sistema de Colores - Soccer Analytics App
 * Paleta de colores verde/blanco con tema de fútbol
 */

const colors = {
  // Colores primarios - Verde césped
  primary: {
    50: '#e8f5e9',   // Verde muy claro
    100: '#c8e6c9',  // Verde claro
    200: '#a5d6a7',  // Verde suave
    300: '#81c784',  // Verde medio-claro
    400: '#66bb6a',  // Verde medio
    500: '#4caf50',  // Verde estándar (más brillante que el actual)
    600: '#43a047',  // Verde medio-oscuro
    700: '#388e3c',  // Verde oscuro
    800: '#2e7d32',  // Verde muy oscuro
    900: '#1b5e20',  // Verde césped oscuro (color actual del theme)
  },

  // Colores secundarios - Amarillo/Dorado (tarjetas, acentos)
  secondary: {
    50: '#fffde7',
    100: '#fff9c4',
    200: '#fff59d',
    300: '#fff176',
    400: '#ffee58',
    500: '#ffd54f',  // Amarillo dorado
    600: '#ffc107',
    700: '#ffb300',
    800: '#ffa000',
    900: '#ff8f00',
  },

  // Neutros - Blanco y grises
  neutral: {
    white: '#ffffff',
    50: '#fafafa',
    100: '#f5f5f5',  // Background actual
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    black: '#000000',
  },

  // Colores de estado - Material Design shade scales
  success: {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    main: '#66bb6a',   // Victoria
  },
  warning: {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    main: '#ffa726',   // Empate
  },
  error: {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    main: '#ef5350',   // Derrota
  },
  info: {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    main: '#29b6f6',   // Información
  },

  // Colores específicos de fútbol
  football: {
    yellowCard: '#ffd54f',  // Tarjeta amarilla
    redCard: '#ef5350',     // Tarjeta roja
    pitch: '#4caf50',       // Verde césped brillante
    pitchDark: '#1b5e20',   // Verde césped oscuro
    win: '#66bb6a',         // Victoria
    draw: '#ffa726',        // Empate
    loss: '#ef5350',        // Derrota
  },

  // Colores de fondo
  background: {
    default: '#f5f5f5',
    paper: '#ffffff',
    dark: '#1b5e20',
  },

  // Colores de texto
  text: {
    primary: '#212121',
    secondary: '#616161',
    disabled: '#9e9e9e',
    hint: '#bdbdbd',
    white: '#ffffff',
  },

  // Divisores y bordes
  divider: '#e0e0e0',
  border: '#eeeeee',
};

export default colors;
